import React from 'react'
import { Modal, Empty, Button, Icon } from 'antd'
import { ImagePreview } from '../../../../../components'
import './LocationSelectionModal.scss'

const LocationSelectionModal = ({
  visible,
  onCancel,
  onSelect,
  locationMap = {},
  locationReference = {},
  currentLocationKey
}) => {
  const keys = Object.keys(locationMap || {})

  const renderLocationItem = key => {
    const refs = locationReference || {}
    // Handle both wrapped and unwrapped keys
    const refKey = refs[`__${key}__`] ? `__${key}__` : key
    const reference = refs[refKey]
    const imageSrc =
      reference &&
      (reference.uri || reference.url || reference.image || reference.src)

    const isSelected =
      currentLocationKey &&
      (currentLocationKey === key || currentLocationKey === `__${key}__`)

    return (
      <div
        key={key}
        className={`location-card-item ${isSelected ? 'is-selected' : ''}`}
      >
        {isSelected && (
          <div className="selected-badge">
            <Icon type="check" />
          </div>
        )}

        <div className="location-image-wrapper">
          {imageSrc ? (
            <ImagePreview
              src={imageSrc}
              alt={key}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <div className="no-image">
              <Icon type="picture" />
              <span>No Image</span>
            </div>
          )}
        </div>

        <div className="location-content">
          <div className="location-header">
            <h4 title={key}>{key}</h4>
            <p title={locationMap[key]}>{locationMap[key]}</p>
          </div>

          <div className="location-action">
            {isSelected ? (
              <Button type="dashed" block className="selected-btn">
                <Icon type="check-circle" /> Selected
              </Button>
            ) : (
              <Button type="primary" ghost block onClick={() => onSelect(key)}>
                Select
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <Modal
      maskClosable={false}
      title="Select Location Reference"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={1000}
      centered
      wrapClassName="location-selection-modal"
    >
      {keys.length > 0 ? (
        <div className="location-grid">{keys.map(renderLocationItem)}</div>
      ) : (
        <Empty description="No locations available. Add locations in the Location Setup step." />
      )}
    </Modal>
  )
}

export default LocationSelectionModal
